import { spacing } from '@constants/spacing';
import { styled, Typography, type Theme } from '@mui/material';
import type { Kit } from '@partful/shared-types';
import { useTranslation } from 'react-i18next';

interface KitNotesProps {
  readonly currentKit: Kit;
}

export function KitNotes({ currentKit }: KitNotesProps) {
  const { t } = useTranslation('partsCatalogue');

  const { description } = currentKit;

  return (
    <NotesContainer>
      <Typography
        variant="body1"
        sx={{
          color: (theme: Theme) => theme.palette.sidebarBackground.contrastText,
          opacity: 0.7,
        }}
      >
        {t('kitSection.notesTitle')}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: (theme: Theme) => theme.palette.sidebarBackground.contrastText,
        }}
      >
        {description}
      </Typography>
    </NotesContainer>
  );
}

const NotesContainer = styled('div')`
  padding-top: ${spacing.mediumSpacing};
  word-break: break-word;
`;
